import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { CurrencyInfo } from '@/core/currency/interfaces';
import { formatCurrency } from '@/core/currency/helpers';
import { PAYMENT_METHOD_ID, PaymentMethod } from '@/core/payment-methods/constants';

@Component({
    data() {
        return {
            discount: false
        };
    }
})
export default class DiscountDetails extends Vue {
    @Prop(Boolean)
    value: boolean;

    @Prop(Object)
    currency: CurrencyInfo;

    @Prop()
    formatPattern: string;

    @Prop(Number)
    amount: number;

    @Prop(Number)
    redeemedAmount: number;

    @Prop(Object)
    selectedMethod: PaymentMethod | null;

    discount: boolean;

    mounted() {
        this.discount = this.value;
    }

    @Watch('discount')
    onChangeSelectValue(value) {
        this.$emit('input', value);
    }

    @Watch('value')
    onChangeValue() {
        this.discount = this.value;
    }

    get isDiscountShown() {
        return this.discount &&
            this.redeemedAmount &&
            this.selectedMethod?.id === PAYMENT_METHOD_ID.CreditCard;
    }

    formatAmount(amount) {
        return formatCurrency(
            (amount.toFixed(2)).toString(),
            this.currency.format,
            this.formatPattern
        );
    }

    calculateDiscount() {
        let result = this.amount - this.redeemedAmount;

        if (result < 0) {
            result = 0;
        }

        return formatCurrency(
            (result.toFixed(2)).toString(),
            this.currency.format,
            this.formatPattern
        );
    }
}
